import "./polyfills.ts";

import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { enableProdMode } from "@angular/core";
import { environment } from "./environments/environment";
import { AppModule } from "./app/app.module";
import { TestingModule } from "./app/testing/testing.module";

if (environment.mode == "production") {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule, <any>TestingModule);
